<template>
  <Modal
    name="UNLINK_ASAAS_HOST_MODAL"
    :title="$t('host.label.unlinkAsaasAccount')"
    actions
  >
    <template v-slot:body>
      <span>
        {{ $t('host.label.asaas.unlinkWarning', { host: host.name })}}
      </span>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        elevation="0"
        class="mr-5"
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        :loading="isLoading"
        color="primary"
        elevation="0"
        @click="linkAsaasHost"
      >
        {{ $t('host.label.asaas.unlink')}}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ModalUnlinkAsaasHost',

  components: {
    Modal
  },

  computed: {
    ...mapGetters(['isLoading', 'host']),
  },

  methods: {
    ...mapActions(['unlinkHostAsaasAccount']),
    ...mapMutations(['closeAllModals']),

    linkAsaasHost() {
      this.unlinkHostAsaasAccount({
        host_id: this.host?.id,
      })
    },
  },
}
</script>
